// Dependencies
import React, { useState, useEffect } from "react"
import { graphql } from "gatsby"
// Hooks & Helpers
import useUpdateSizes from "../hooks/useUpdateSizes"
// Components
import Layout from "../components/Layout"
import Section from "../components/Section"
import RichText from "../components/RichText"
import Video from "../components/Video"
import Loop from "../components/Loop"
import Animation from "../components/Animation"
import TextCursor from "../components/TextCursor"

function useCurrentIndex(length) {

	const [index, set] = useState(-1)

	const update = () => {
		set(prev => {
			return prev === length - 1 ? 0 : prev + 1
		})
	}

	return [index, update]
}

const IndexPage = ({ data }) => {

  // ANIMATION UX
  const animations = data.allContentfulAnimation.edges
	const [currentIndex, updateIndex] = useCurrentIndex(animations.length)
  const [clickPosition, setClickPosition] = useState({ x: 0, y: 0 })

	// CURSOR UX
  // const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 })
  const [cursorText, setCursorText] = useState("Click")
  const [cursorVisible, setCursorVisible] = useState(true)
	const [clicked, setClicked] = useState(false)

  // VIDEO UX
  // const [isPlaying, setPlaying] = useState(false);

	// SCROLL UX
	const [hasScrolled, setScrolled] = useState(true)

  const handlePageClick = (e) => {
    if (e.target.tagName.toLowerCase() !== 'video' && e.target.tagName.toLowerCase() !== 'a') {

			updateIndex()

      setClickPosition({ x: e.clientX, y: e.clientY + document.documentElement.scrollTop })

			setClicked(true)
    }
  }

  // const getCursorPosition = (e) => {
  //   !cursorVisible && setCursorVisible(true)

  //   setCursorPosition({ x: e.clientX, y: e.clientY })

  //   if (e.target.tagName.toLowerCase() === 'a') {
  //     setCursorText("")
  //   } else if (e.target.tagName.toLowerCase() === 'video') {
  //     setCursorText(isPlaying ? "Pause Showreel" : "Play Showreel")
  //   } else {
  //     setCursorText("Click")
  //   }
  // }

	useEffect(() => {
		let timeout = setTimeout(() => {
			setScrolled(false)
		}, 4000)

		const clear = () => {
			if (window.pageYOffset > 25) {
				if (!hasScrolled && window.pageYOffset > 50) {
					setScrolled(true)
				}
				clearTimeout(timeout)
			}
		}

		window.addEventListener("scroll", clear);

		return () => window.removeEventListener("scroll", clear);
	}, [hasScrolled])

	// Updates var(--app-height); in CSS when window changes
	useUpdateSizes()

	const linkHandlers = {
		onMouseEnter: () => {
			setCursorText("")
			setCursorVisible(false)
		},
		onMouseLeave: () => {
			setCursorText("Click")
			setCursorVisible(true)
		}
	}

  return(
    <Layout onMouseDown={handlePageClick} onMouseMove={null}>

      <Loop colourSchemes={data.allContentfulHomepage.edges[0].node.colourSchemes}>
        <Section loadAnimation={true}>
					<svg className="layer-2" width="563" height="302" viewBox="0 0 563 302" fill="none" xmlns="http://www.w3.org/2000/svg">
						{/* <rect width="563" height="302" fill="#C4C4C4"/> */}
						<path fill="black" fillRule="evenodd" clipRule="evenodd" d="M357.355 11.0219C357.355 17.4031 352.569 22.479 346.188 22.479C339.662 22.479 334.876 17.4031 334.876 11.167C334.876 4.78584 339.952 0 346.188 0C352.569 0 357.355 5.0759 357.355 11.0219ZM354.745 36.2564V116.891H337.632V36.2564H354.745ZM539.503 108.189C539.503 140.965 521.085 151.117 500.201 151.117C485.118 151.117 469.165 146.186 462.349 127.913L478.012 122.257C481.783 131.683 488.744 136.469 499.621 136.469C513.253 136.469 522.245 128.493 522.245 110.8C522.245 106.304 523.115 101.663 524.275 99.0525H521.955C516.154 112.395 506.437 116.601 496.285 116.601C472.791 116.601 459.159 97.7472 459.159 75.2683C459.159 51.049 474.966 33.936 495.705 33.936C508.032 33.936 517.459 40.8972 521.52 53.3694H523.84C522.535 45.248 522.535 40.7522 522.535 36.2564H539.503V108.189ZM476.997 74.9782C476.997 89.0457 486.423 100.213 499.621 100.213C512.818 100.213 522.68 89.0457 522.68 74.9782C522.68 60.7657 512.673 50.1789 499.621 50.1789C486.423 50.1789 476.997 61.0558 476.997 74.9782ZM200.717 119.356C225.081 119.356 241.904 101.808 241.904 76.7185C241.904 51.6291 225.081 33.936 200.717 33.936C176.353 33.936 159.385 51.6291 159.385 76.7185C159.385 101.808 176.353 119.356 200.717 119.356ZM200.717 103.113C186.94 103.113 177.368 92.0912 177.368 76.7185C177.368 61.2008 186.94 50.1789 200.717 50.1789C214.495 50.1789 224.066 61.2008 224.066 76.7185C224.066 92.0912 214.495 103.113 200.717 103.113ZM563 244.572C563 259.799 550.818 270.241 532.11 270.241C514.416 270.241 501.509 261.105 497.448 247.617L513.401 242.396C517.172 251.823 525.003 256.029 531.965 256.029C537.331 256.029 544.727 253.708 544.727 246.312C544.727 239.496 538.056 237.465 531.82 235.58L523.408 233.115C514.126 230.359 501.219 224.558 501.219 209.33C501.219 193.813 514.561 184.821 530.514 184.821C546.032 184.821 557.199 193.523 560.68 204.98L544.727 210.201C542.551 204.255 537.911 198.889 529.789 198.889C523.263 198.889 518.477 202.514 518.477 208.025C518.477 215.277 527.179 218.032 533.995 219.917L540.666 221.803C548.642 224.123 563 228.329 563 244.572ZM390.234 270.241C408.508 270.241 423.155 260.525 428.956 243.847L413.003 237.61C408.943 247.762 400.821 253.998 390.379 253.998C377.037 253.998 366.74 243.702 366.74 227.459C366.74 212.521 375.732 201.064 389.654 201.064C398.936 201.064 406.912 205.85 410.393 215.857L426.636 209.33C420.69 193.233 406.187 184.821 389.799 184.821C366.305 184.821 348.757 201.499 348.757 227.604C348.757 253.708 366.45 270.241 390.234 270.241ZM114.135 211.361C114.135 245.297 88.9007 270.241 56.995 270.241C25.6695 270.241 0 246.022 0 211.361C0 176.845 25.6695 152.335 57.1401 152.335C88.9007 152.335 114.135 177.425 114.135 211.361ZM19.2884 211.361C19.2884 235.87 36.4014 252.983 57.2851 252.983C78.1688 252.983 94.8467 235.435 94.8467 211.361C94.8467 187.577 78.4588 169.593 57.2851 169.593C36.2564 169.593 19.2884 187.142 19.2884 211.361Z" />
					</svg>
          <svg className="layer-4" width="563" height="303" viewBox="0 0 563 303" fill="none" xmlns="http://www.w3.org/2000/svg">
						{/* <rect width="563" height="302" fill="#C4C4C4"/> */}
						<path fill="black" fillRule="evenodd" clipRule="evenodd" d="M42.7464 108.777V108.778V108.779V108.78V108.78C42.7403 111.489 42.7342 114.192 42.7342 116.891H24.1709V3.77063H44.4745C59.2671 31.9056 72.6095 61.2008 83.1963 93.1064H86.3869C97.4088 61.2008 110.751 31.9056 125.254 3.77063H145.557V116.891H126.994C126.994 114.234 126.988 111.578 126.982 108.916C126.928 85.5564 126.874 61.7069 130.91 33.0658H128.589C119.989 53.7245 111.45 72.1539 103.475 89.3637L103.475 89.3642C99.0773 98.854 94.8517 107.973 90.8827 116.891H78.7005C74.8476 108.234 70.7701 99.3873 66.5338 90.1958C58.4921 72.7481 49.8777 54.0579 41.1389 33.0658H38.8185C42.8544 60.6661 42.7998 84.9939 42.7464 108.777ZM391.353 116.891V74.2531C391.353 59.1704 399.909 50.1789 411.511 50.1789C423.839 50.1789 428.769 60.3307 428.769 73.673V116.891H446.027V66.1317C446.027 43.3627 432.105 33.936 417.457 33.936C407.161 33.936 397.444 38.5768 391.063 52.2092H388.742C391.063 44.8129 391.063 40.6072 391.063 36.2564H374.24V116.891H391.353ZM295.954 116.891L325.394 36.2564H307.121C299.869 56.1249 293.343 75.4133 287.542 99.7776H284.352C278.406 75.4133 271.879 56.1249 264.483 36.2564H245.775L275.36 116.891H295.954ZM473.777 270.373C479.142 270.373 484.653 269.358 488.714 267.037V251.52C484.944 253.55 480.883 254.71 477.112 254.71C466.09 254.71 466.09 244.704 466.09 236.727V202.791H488.714V187.273H466.09V164.069H448.832V187.273H432.879V202.791H448.832V242.673C448.832 251.23 448.832 270.373 473.777 270.373ZM337.272 246.022C331.761 260.234 317.839 270.241 299.566 270.241C275.927 270.241 258.233 253.418 258.233 227.749C258.233 202.949 274.911 184.821 298.405 184.821C317.114 184.821 336.692 196.568 336.692 227.024V232.97H275.636C276.942 246.747 286.948 254.869 299.566 254.869C309.572 254.869 317.404 248.922 321.174 239.641L337.272 246.022ZM298.26 199.614C286.368 199.614 278.537 207.88 276.507 218.757H319.289C318.129 205.125 308.267 199.614 298.26 199.614ZM234.228 173.364C240.609 173.364 245.395 168.288 245.395 162.052C245.395 155.816 240.609 150.885 234.228 150.885C227.702 150.885 223.061 155.961 223.061 162.052C223.061 168.143 227.702 173.364 234.228 173.364ZM217.405 302.002C242.784 302.002 242.784 281.988 242.784 268.791V187.142H225.671V269.081C225.671 276.042 225.671 286.629 213.779 286.629C210.008 286.629 205.803 285.614 201.452 283.584V298.666C205.513 300.552 210.443 302.002 217.405 302.002ZM208.552 227.314C208.552 253.853 191.439 270.241 171.715 270.241C159.678 270.241 150.252 264.005 145.321 253.128H143C145.091 258.877 145.063 262.86 145.037 266.562C145.034 266.969 145.031 267.373 145.031 267.776H128.208V151.755H145.321C145.321 154.794 145.347 157.827 145.374 160.89C145.487 173.904 145.604 187.439 143.726 204.11H146.046C152.427 189.607 162.144 184.821 172.876 184.821C194.63 184.821 208.552 203.529 208.552 227.314ZM145.031 227.604C145.031 243.266 155.038 253.998 168.09 253.998C181.287 253.998 190.714 242.831 190.714 227.604C190.714 212.376 181.287 201.064 167.945 201.064C154.893 201.064 145.031 212.231 145.031 227.604Z" />
					</svg>
        </Section>

        <Section>
          <RichText content={data.allContentfulHomepage.edges[0].node.about} linkHandlers={linkHandlers} />
        </Section>

        <Section>
          <Video 
						src={data.allContentfulHomepage.edges[0].node.showreel.file.url} 
						poster={data.allContentfulHomepage.edges[0].node.showreelCoverImage.file.url} 
						setCursorText={setCursorText} 
					/>
					<h5 className="mtx2">Watch Showreel</h5>
				</Section>
      </Loop>

      {animations.map((animation, index) => (
        <Animation
          json={animation.node.animationJsonFile.localFile.publicURL}
          isActive={index === currentIndex}
          key={`${animation.id}${index}`}
          clickPosition={clickPosition}
        />
      ))}

      <TextCursor
				className={clicked ? "click" : ""}
				content={cursorText}
				visible={cursorVisible}
				setClicked={setClicked}
			/>

			<div className={`pfix b0 w100 flex-center transition ${hasScrolled ? "op0" : ""}`}>
				<h4 className="inner">&#8964;</h4>
			</div>

    </Layout>
  )
}

export default IndexPage

export const IndexPageQuery = graphql`
  query IndexPageQuery {
    allContentfulHomepage {
      edges {
        node {
          title
          showreel {
            file {
              url
            }
          }
					showreelCoverImage {
	          file {
	            url
	          }
	        }
          about {
            raw
          }
          colourSchemes {
            foreground
            background
            highlight
          }
        }
      }
    }
    allContentfulAnimation {
      edges {
        node {
          animationJsonFile {
            file {
              url
            }
            localFile {
              publicURL
            }
          }
        }
      }
    }
  }
`
